
// src/helpers/shallow-equal.js

import some from 'lodash/some'

export default function shallowEqual(objA, objB) {
  if (objA === objB)
    return true;

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB)
    return false;

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length || some(keysA, (key, i)=> key !== keysB[i]))
    return false;

  return !some(objA, (value, key)=> {
    if (typeof value != typeof objB[key])
      return true
    if (value instanceof Array) {
      if (value.length != objB[key].length || Object.keys(value).length != Object.keys(objB[key]).length)
        return true
      return some(Object.keys(value), (_key)=> value[_key] !== objB[key][_key])
    }
    if (typeof value == 'function')
      return false
    if (value !== objB[key])
      return true
    return false
  })
};



// WEBPACK FOOTER //
// ./src/helpers/shallow-equal.js